export default function wpImageUrl(url: string) {
  if (url.startsWith('/wp-content')) {
    return url.replace(
      '/wp-content',
      `https://${process.env.GATSBY_WORDPRESS_URL_PATH}/wp-content`
    );
  }
  return url;
}
